import React, { PropsWithChildren } from 'react';
import { VideoElement } from 'components/_new/NewSlateEditor/types';
import { EmbedElement } from './EmbedElement';

type VideoProps = PropsWithChildren<{
	element: VideoElement;
	attributes: Record<string, any>;
}>;

const Video = ({ attributes, element, children }: VideoProps) => {
	const { url, alt } = element;

	return (
		<EmbedElement attributes={attributes} element={element} aspectRatio={16 / 9}>
			<div className="embed-video">
				<iframe
					src={url}
					frameBorder="0"
					title={alt}
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					referrerPolicy="strict-origin-when-cross-origin"
				/>
			</div>
			{children}
		</EmbedElement>
	);
};
export default Video;
